// removed by extract-text-webpack-plugin
module.exports = {"purchaseAddressWrap":"qempo_PurchaseAddress_purchaseAddressWrap-3dsSMzp","title":"qempo_PurchaseAddress_title-28swepO","content":"qempo_PurchaseAddress_content-jyTmO_A"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Purchase/components/PurchaseAddress/PurchaseAddress.scss
// module id = 1847
// module chunks = 0